import React from 'react'
import { Form, Spin } from 'antd'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import { BaseInfoProps } from './interface'
import './index.less'

const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 6 },
}

export default function BaseInfo(props: BaseInfoProps) {
  /*个人帐号信息-个人信息 */
  const { data, loading } = useRequest(async () => {
    const { data } = await api.queryUserInfoUsingPOST()
    return data
  })

  return (
    <Spin spinning={loading}>
      <div className="id-base-info">
        <p className="base-info-t">个人信息</p>
        <Form {...layout} className="info-form">
          <Form.Item label="员工账号编码">{data?.userAccountCode}</Form.Item>
          <Form.Item label="员工姓名">{data?.username}</Form.Item>
          <Form.Item label="员工角色">{data?.userType}</Form.Item>
          <Form.Item label="员工电话">{data?.mobile}</Form.Item>
          <Form.Item label="企业全称">{data?.enterpriseName}</Form.Item>
          <Form.Item label="企业简称">{data?.shortName}</Form.Item>
        </Form>
      </div>
    </Spin>
  )
}
